"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="262260" id="hero-section" className="relative w-full h-screen min-h-[600px] flex flex-col justify-between overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/contact_office_background.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/contact_office_background.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521869/img/contact_office_background.png-wvc-sizes" alt="Professional office environment" className="w-full h-full object-cover" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-primary/40 bg-gradient-to-b from-primary/60 via-primary/20 to-primary/80 backdrop-blur-[2px]"></div>
      </div>

      {}
      <div className="relative z-10 flex-1 flex flex-col justify-between w-full max-w-[1920px] mx-auto px-6 md:px-12 py-12 md:py-16">

        {}
        <div className="flex justify-between items-center w-full mt-4 md:mt-8">
          <div className="text-white text-sm md:text-base uppercase tracking-[0.2em] font-default font-medium drop-shadow-md">
            Connect
          </div>
          <div className="text-white text-sm md:text-base uppercase tracking-[0.2em] font-default font-medium drop-shadow-md">
            <Link to="#contact-form" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
              Inquire <ArrowDown className="w-4 h-4" />
            </Link>
          </div>
        </div>

        {}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none px-6">
          <p ref={textRef} className={`text-white text-2xl md:text-3xl lg:text-4xl leading-tight md:leading-snug font-default font-medium max-w-3xl text-center drop-shadow-lg transition-all duration-1000 transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            We are here to help you navigate your next big challenge. Reach out to start a conversation about your goals.
          </p>
        </div>

        {}
        <div ref={titleRef} className={`flex justify-between items-end w-full mt-auto overflow-hidden transition-all duration-1000 delay-300 transform ${isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h1 className="text-white text-[22vw] md:text-[18vw] lg:text-[16vw] leading-[0.75] font-default tracking-tighter uppercase m-0 p-0 drop-shadow-2xl">
            Contact
          </h1>
          <h1 className="text-white text-[22vw] md:text-[18vw] lg:text-[16vw] leading-[0.75] font-default tracking-tighter uppercase m-0 p-0 drop-shadow-2xl">
            Us
          </h1>
        </div>

      </div>
    </section>;
}